import React from 'react'
import { ComponentData } from '../data/ComponentContext'

function DimensionInputs({ className, displayErrors }) {

  const { width, length, height, setWidth, setLength, setHeight, dimensionsAreValid } = ComponentData()

  return (
    <div className={className}>
      <p>Länge x Breite x Höhe</p>
      <div className={displayErrors && !dimensionsAreValid ? "dimension-inputs input-fields error" : "dimension-inputs input-fields"}>

        <div>
          <input type="number" value={length} onChange={(e) => {
            setLength(e.target.value)
          }} />
          <span className='unit-label'>mm</span>
        </div>

        <div>
          <input type="number" value={width} onChange={(e) => {
            setWidth(e.target.value)
          }} />
          <span className='unit-label'>mm</span>
        </div>

        <div>
          <input type="number" value={height} onChange={(e) => {
            setHeight(e.target.value)
          }} />
          <span className='unit-label'>mm</span>
        </div>

        {displayErrors && !dimensionsAreValid ? <p className='error'>Felder dürfen nicht leer oder "0" sein!</p> : null}

      </div>
    </div>
  )
}

export default DimensionInputs